import React, {Component} from 'react';
import config, {API_ROOT} from "../../config";
import fetch from 'cross-fetch';
import {fetchBusinessById, fetchJobs} from "../../services/index";
import PageLoader from "../../parts/PageLoader";
import ShiftPageContent from "./ShiftPageContent";


class ShiftPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shift: null,
      business: null,
      jobs: null,
    };
  }

  componentDidMount() {
    window.analytics.page("Shift");

    // Get shift by slug. This should also be in redux but we're keeping it here since redux is more for the dashboard now
    fetch(API_ROOT + '/shifts/?slug=' + this.props.match.params.slug).then(response => {
      if (response.status === 200) {
        response.json().then(shifts => {
          if (shifts.length > 0) {
            const shift = shifts[0];
            this.setState({
              shift: shift
            });
            fetchBusinessById(shift.business).then(business => {
              this.setState({
                business: business
              });
            });
            fetchJobs().then(jobs => {
              this.setState({
                jobs: jobs
              });
            });
          } else {
            // If it doesn't exist, we want to send them to 404
            this.props.history.push(config.routes.notFound);
          }
        });
      } else {
        // Something went wrong. We should error, but for now we'll just 404
        this.props.history.push(config.routes.notFound);
      }
    });
  }

  render() {
    const {shift, business, jobs} = this.state;

    if (!(shift && business && jobs)) {
      return (
        <PageLoader/>
      );
    }

    window.prerenderReady = true;
    return <ShiftPageContent shift={shift} business={business} jobs={jobs}/>
  }
}

export default ShiftPage;




// WEBPACK FOOTER //
// ./src/pages/shift-page/index.js